import { Injectable } from "@angular/core";
import { ApiService } from "../api.service";

const PATH = "account-signal-categories";

@Injectable({
  providedIn: "root",
})
export class AccountSignalCategoriesHandlerService {
  constructor(private apiService: ApiService) {}

  accountSignalCategoriesGet(accountID: number) {
    return this.apiService.get(`${PATH}/${accountID}`);
  }

  accountSignalCategoryGet(accountID: number, categoryID: number) {
    return this.apiService.get(`${PATH}/${accountID}/${categoryID}`);
  }

  accountSignalCategoryPost(accountID: number, signalCategoryDTO: any) {
    return this.apiService.post(`${PATH}/${accountID}`, signalCategoryDTO);
  }

  accountSignalCategoryPut(accountID: number, signalCategoryDTO: any) {
    return this.apiService.put(
      `${PATH}/${accountID}/${signalCategoryDTO.id}`,
      signalCategoryDTO,
    );
  }

  accountSignalCategoryDelete(accountID: number, categoryID: any) {
    return this.apiService.delete(`${PATH}/${accountID}/${categoryID}`);
  }
}
